import React from 'react';
import Q from "js/quantum";
import "css/main.scss";
import Global from 'global';
import { setCurrentNav, UserRole, UserPermission, UserModule } from './common';

class UserTr extends React.Component {

    getPermDesc(perm) {
        return UserPermission.kAll[perm];
    }
    render() {
        const user = this.props.user;
        this.currentUser = Global.user;
        const validClass = user.valid ? "label label-success" : "label label-warning";
        return (
            <tr>
                <td>
                    <a href={`/user/${user._id}`}>
                        <i className="glyphicon glyphicon-user" />
                        <span>{user.name}</span>
                    </a>
                </td>
                <td><a href={`/user/${user._id}`}>{user.email}</a></td>
                <td>
                    {
                        <span className={validClass}>
                            {user.valid ? "Active" : "Banned"}
                        </span>
                     }
                </td>
                <td className="permissions-container">
                    {
                         user.permissions.map((permi, i) => {
                             return <span key={i}>{this.getPermDesc(permi)}</span>;
                         })
                     }
                </td>
                <td>
                    { UserRole.isRoot(this.currentUser.role) ?
                        <span>{UserModule.kDescDict[user.module]}</span> :
                        <span>{UserRole.kDescDict[user.role]}</span>
                    }
                </td>
                { this.props.showOp ? (
                    <td><a href={`/user/${user._id}/statistics`}>查看工作量</a></td>) : null
                 }
            </tr>
        );
    }
}

export default class UserList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
        };
        this.currentUser = Global.user;
    }
    componentDidMount() {
        setCurrentNav('用户列表');
        this.init();
    }
    init() {
        Q.get("/api/users", { query: { format: "json" } })
        .done((data) => {
            this.setState({
                users: data.results,
            });
        });
    }
    render() {
        const permissions = Global.user.permissions.filter(p => p < 200);
        const showOp = permissions.length > 0;   // 隐藏操作列
        return (
            <div id="users-list">
                <div className="userlist-container">
                    <table className="table table-wrapper">
                        <thead>
                            <tr>
                                <th>用户名</th>
                                <th>邮箱</th>
                                <th>状态</th>
                                <th>权限</th>
                                { UserRole.isRoot(this.currentUser.role) ? <th>模块</th> :
                                <th>角色</th>}
                                { showOp ? <th>操作</th> : null}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.users.map(user =>
                                    <UserTr key={user._id} user={user} showOp={showOp} />)
                            }
                        </tbody>
                    </table>
                </div>
                <a role="button" className="btn btn-success" href="/admin/adduser">添加用户</a>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./js/user/userlist.jsx